import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getProgramList } from '../../../services/program'
import { Box, Container, Flex, Text, Button, Grid } from '@mantine/core'
import { IconCircleArrowRight } from '@tabler/icons-react'
import SkeletonCard from '../../ui/SekeletonCard'
import ProgramCard from '../Program/ProgramCard'
import classes from '../../../pages/Home/Home.module.css'


const defaultCaption = {
  'training' : {
    title: 'Training',
    caption: 'Program pelatihan dan webinar dari PT Katalis Talenta Indonesia'
  },
  'bootcamp' : {
    title: 'Bootcamp',
    caption: 'Program belajar intensif dengan video pembelajaran dengan Tutor berpengalaman'
  }
}

const TrainingSection = ({ type }) => {
  const params = {
    take: 4,
    kind: type,
    orderBy: 'nearest',
    order: 'asc'
  }
  const navigate = useNavigate()
  const [programList, setProgramList] = useState([])
  const [ loading, isLoading ] = useState(true)

  const handleGetProgramList = async () => {
    isLoading(true)
    try {
      const response = await getProgramList(params)
      setProgramList(response.data)
    } catch (error) {
      console.log(error)
    } finally {
      isLoading(false)
    }
  }

  useEffect(() => {
    handleGetProgramList()
    // eslint-disable-next-line
  }, [])

  const loadingData = (number) => Array.from({ length: number }, (_, i) => {
    return (
      <Grid.Col span={{base: 6, md: 6, lg: 3 }} key={i}>
        <SkeletonCard />
      </Grid.Col>
    )
  })

  const mappingDataList = (program) => {
    if (program.length > 0) {
      const remap = program.map((val, index) => {
        return (
          <Grid.Col span={{base: 6, md: 6, lg: 3 }} key={index}>
            <ProgramCard data={val} />
          </Grid.Col>
        )
      })
      return remap
    }
  }

  return (
    <Box className={type !== 'training' ?  classes.defaultSection : classes.bgGraySection}>
      <Container fluid className={classes.section}>
        <Flex className={classes.paddingPage} justify="space-between" align="center">
          <Box>
            <Text className={classes.titleSection} mb={6}>{defaultCaption[type].title}</Text>
            <Text className={classes.captionSection}>{defaultCaption[type].caption}</Text>
          </Box>
          <Button visibleFrom='md' rightSection={<IconCircleArrowRight size={18}/>} color='yellow.7' radius={12} onClick={() => navigate(`/${params.kind}`)}>Selengkapnya</Button>
        </Flex>
        <Box mt={20}>
          <Grid gutter='lg' className={classes.gridProgramCard} align='center'>
            {loading ? loadingData(4) : mappingDataList(programList)}
          </Grid>
        </Box>
        <Flex mt={50} justify="center" align="center">
          <Button hiddenFrom='md' size='xs' rightSection={<IconCircleArrowRight size={14}/>} color='yellow.7' radius={10} onClick={() => navigate(`/${params.kind}`)}>Selengkapnya</Button>
        </Flex>
      </Container>
    </Box>
  )
}

export default TrainingSection